export interface IUserGroupObjectType {
  description: string;
  id: UserGroupObjectTypeEnum;
  name: string;
}

export enum UserGroupObjectTypeEnum {
  FILE_RESOURCE = '1',
}
